<!--
  IpForm : Mac Component

  @since 2017-11-10
  @author kdydesign.kim
-->

<template>
  <div class="inline-group">
    <div v-for="(seg, index) in macSegments" class="bs">
      <q-input type="text"
               align="center"
               style="width:50px;"
               class="bs bs-q-input bs-q-input-default"
               maxLength="2"
               v-validate="getMacAddressRules"
               :ref="`mac_${index}`"
               :key="`${name}_@macSegment@_${index}`"
               :name="`${name}_@macSegment@_${index}`"
               :value="seg"
               :error="dataVvScope === '' ? errors.has(`${name}_@macSegment@_${index}`) : errors.has(`${dataVvScope}.${name}_@macSegment@_${index}`)"
               :disable="disable"
               :readonly="readonly"
               :maxlength="2"
               :data-vv-scope="dataVvScope || null"
               @input="onInputMacAddress($event, index)"
               @keydown="onKeydown($event, index)"
      />
      <span v-if="index < 5" class="contents-option-con">:</span>
    </div>

    <q-btn :title="`MAC ${$t('cmn.copy')}`"
           v-clipboard:copy="macSegments.join(':')"
           :disable="disable"
           color="primary"
           outline="outline"
           class="bs bs-q-btn-sm bs-q-btn-icon-sm bs-q-btn-line">
      <q-icon class="bs-q-btn-icon bs-q-btn-icon-ip-copy-sm"/>
    </q-btn>
  </div>
</template>

<script>
  const regex = /[0-9A-Fa-f][0-9A-Fa-f]$/
  const regexChar = /[0-9A-Fa-f]$/
  const ipRegex = /^([0-9A-Fa-f]{2}[:-]){5}([0-9A-Fa-f]{2})$/

  export default {
    name: 'MacAddress',
    props: {
      mac: {
        type: String,
        default: ''
      },
      name: {
        type: String,
        required: true
      },
      error: {
        type: Boolean,
        default: false
      },
      disable: {
        type: Boolean,
        default: false
      },
      isValid: {
        type: Boolean,
        default: true
      },
      required: {
        type: Boolean,
        default: false
      },
      readonly: {
        type: Boolean,
        default: false
      },
      validator: {
        type: Object,
        default: void 0,
        validator: function (value) {
          return value
        }
      },
      dataVvScope: {
        type: String,
        default: ''
      },
      haForce: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        self: this,
        maskValue: void 0,
        macSegments: ['', '', '', '', '', '']
      }
    },
    computed: {
      getMacAddressRules () {
        return this.disable ? '' : this.required ? 'required|isValidMacComponent' : this.isValid && this.checkInputMacAddress ? 'required|isValidMacComponent' : ''
      },
      checkInputMacAddress () {
        for (const seg of this.macSegments) {
          if (seg !== '') {
            return true
          }
        }

        return false
      }
    },
    created () {
      // 전달된 Validator가 없을경우 자기 자신의 Validator 객체를 전달한다.
      this.$validator = this.validator || this.$validator
    },
    mounted () {
      // Watch에서 인식하지 못할 경우를 대비한 초기값 설정
      let mac = this.mac

      // MAC 주소 분리
      this.macSegments = mac ? mac.split(':') : ['', '', '', '', '', '']

      let inputCons = this.$el.getElementsByTagName('input')
      _.each(inputCons, (thisCon, index) => {
        thisCon.addEventListener('paste', (event) => {
          this.onPaste(event, index)
        })
      })
    },
    beforeDestroy () {
      // MAC 컴포넌트 초기화
      this.clear()

      // 셀프 객체 초기화
      this.self = null
    },
    methods: {
      /*
        이름: onInputMacAddress
        설명: MAC 주소를 입력할 때 발생하는 이벤트. 내부 모델에 값을 입력하고 양방향 바인딩을 수행한다.
      */
      onInputMacAddress (value, index) {
        // 한글 제거
        value = value.replace(/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/g, '')

        // MAC 주소 저장
        let segment = value
        let mac = ''

        // 빈값이 들어가는 경우
        if (!value) {
          // 퀘이사 컴포넌트 내부 모델에 값 입력
          this.$refs[`mac_${index}`][0].$data.model = ''
          this.macSegments.splice(index, 1, '')
        } else {
          // 퀘이사 컴포넌트 내부 모델에 값 입력
          this.$refs[`mac_${index}`][0].$data.model = value

          // MAC 컴포넌트 모델에 값 입력
          this.macSegments[index] = value
        }

        // 다음 컴포넌트 포커스로 진행
        if (regex.test(segment) && segment.length === 2 && index < 5) {
          this.$el.getElementsByTagName('input')[index + 1].focus()
        }

        // 모두 비어있는 경우 확인
        let checkNonEmpty = false
        for (const seg of this.macSegments) {
          if (seg !== '') {
            checkNonEmpty = true
            break
          }
        }

        // 양방향 바인딩을 위한 맥주소 문자열 생성
        mac = this.macSegments.join(':')

        // 양방향 바인딩 수행
        this.$emit('update:mac', checkNonEmpty ? mac : null)

        // 유효성 검사 딜레이 지정 후 수행
        const self = this.self
        setTimeout(function () {
          self.$validator.validateAll()
        }, 50)
      },
      onPaste (event, index) {
        let mac = ''
        const pasteText = event.clipboardData.getData('text/plain')

        if (ipRegex.test(pasteText)) {
          let macSegments = pasteText.split(':')

          macSegments.forEach((segment, i) => {
            if (regex.test(segment)) {
              if (index + i >= 6) {
                return
              }
              this.macSegments.splice(index + i, 1, segment)
            }
          })

          mac = this.macSegments.join(':')

          this.$emit('update:mac', mac)
        }

        event.returnValue = false
      },
      /*
        이름: onKeydown
        설명: 허용되지 않은 값의 입력을 차단한다.
      */
      onKeydown (event, index) {
        // validate char || control + paste
        if (regexChar.test(event.key) || (event.ctrlKey && event.key === 'v')) {
          return
        }
        // block kor
        if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(event.target.value)) {
          event.target.value = ''
          event.returnValue = false
        }
        if (event.key === ':') {
          if (index < 5) {
            this.$el.getElementsByTagName('input')[index + 1].focus()
          }
        }

        // 이벤트 차단
        event.returnValue = false
        event.preventDefault()
      },
      /*
        이름: clear
        설명: 컴포넌트의 상태를 초기화한다.
      */
      async clear () {
        // 유효성 검사 초기화
        await this.validatorClear()

        // 내부 모델 초기화
        this.macSegments = ['', '', '', '', '', '']
      }
    },
    watch: {
      mac (macAddress) {
        this.macSegments = macAddress ? macAddress.split(':') : ['', '', '', '', '', '']
      }
    }
  }
</script>
